import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { PURCHASES_QUERY_KEY } from "../constants";
import { AccountingService } from "../services/Accounting.service";
import { ICreatePurchase } from "../types";

export function useCreatePurchase() {
  const {
    mutate: create,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: (data: ICreatePurchase) =>
      AccountingService.createPurchase(data).catch(async (err: any) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      ToastService.success("Brief ledger created successfully");
      c.invalidateQueries({
        queryKey: [...PURCHASES_QUERY_KEY],
      });
      //   c.invalidateQueries({ queryKey: BRIEF_LEDGER_QUERY_KEY });
      //   c.invalidateQueries({ queryKey: BRIEF_LEDGER_FACETS_QUERY_KEY });
      //   c.invalidateQueries({ queryKey: BRIEF_LEDGER_AGGREGATION_QUERY_KEY });
      //   c.invalidateQueries({ queryKey: BRIEF_TOTAL_AGGREGATION_QUERY_KEY });
    },
  });

  return {
    create,
    isCreating,
    isCreated,
  };
}
